import api from "../api";
import getBaseUrl from "../utils/getBaseUrl";

const root = "/reality-sessions/v2";

export const createRealityStream = (payload) =>
  api.post(root, payload).then(response => response.data);

export const getRealityStream = (sessionCode) =>
  api.get(`${root}/${encodeURIComponent(sessionCode)}`).then(response => response.data);

export const getRealityStreamDirector = (sessionCode) =>
  api.get(`${root}/${encodeURIComponent(sessionCode)}/director`).then(response => response.data);

export const getRealityRecordingsForDoar = (doarId, limit = 50) =>
  api.get(`${root}/doar/${encodeURIComponent(doarId)}/recordings`, { params: { limit } }).then(response => response.data);

export const getActiveRealityStream = (publicationId) =>
  api.get(`${root}/publication/${encodeURIComponent(publicationId)}/active`).then(response => response.data);

export const joinRealityStream = (sessionCode, payload) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/join`, payload).then(response => response.data);

export const heartbeatRealityStream = (sessionCode, deviceId) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/heartbeat`, { deviceId }).then(response => response.data);

export const updateRealityStreamState = (sessionCode, { stateVersion, patch, action = null }) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/state`, { stateVersion, patch, action }).then(response => response.data);

export const postRealityStreamInteraction = (sessionCode, { deviceId, interaction }) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/interaction`, { deviceId, interaction }).then(response => response.data);

export const recordRealitySpatialState = (sessionCode, { spatial, action = null }) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/spatial`, { spatial, action }).then(response => response.data);

export const attachRealityRecordingMedia = (sessionCode, assetId) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/media`, { assetId }).then(response => response.data);

export const assignRealityStreamRole = (sessionCode, payload) =>
  api.post(`${root}/${encodeURIComponent(sessionCode)}/roles`, payload).then(response => response.data);

export const endRealityStream = (sessionCode, stateVersion) =>
  api.delete(`${root}/${encodeURIComponent(sessionCode)}`, { params: { stateVersion } }).then(response => response.data);

export const getRealityStreamReplay = (sessionCode, { after = 0, limit = 250 } = {}) =>
  api.get(`${root}/${encodeURIComponent(sessionCode)}/replay`, { params: { after, limit } }).then(response => response.data);

export function realityStreamEventsUrl(sessionCode, after = 0) {
  const base = String(getBaseUrl() || "").replace(/\/+$/, "");
  return `${base}${root}/${encodeURIComponent(sessionCode)}/events?after=${Math.max(0, Number(after) || 0)}`;
}
